import { useState, useEffect, useRef } from "react";
import {
    Table, Thead, Tbody, Tr, Th, Td, Image, Button, Select,
    Flex, VStack, Box, Text, IconButton, Checkbox, HStack, Input,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
    useDisclosure, FormControl, FormLabel, Divider, Badge, Grid, GridItem,
    Tooltip,
    Switch
} from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import searchIcon from "../../assets/icons/search.svg";
import sortIcon from "../../assets/icons/sort.svg";
import eyeIcon from "../../assets/icons/eye.svg";
import copyIcon from "../../assets/icons/Copy.svg";
import useAxios from "../Context/axiosInstance";
import { useAuth } from "../Context/authContext";
import filterIcon from "../../assets/icons/calendar.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Config } from "../Utils/Config";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { TbDownload } from "react-icons/tb";
import { px } from "framer-motion";

const tableHeadings = [
    "Retailers Name", "User Since", "Valid Until", "Last Active", "Phone", "Email", "Party Code", "Location", "Status", "Profile"
];

const thinScrollbarStyles = {
    scrollbarWidth: "thin", // Firefox
    scrollbarColor: "#A0A0A0 transparent",

    "&::-webkit-scrollbar": {
        width: "6px",  // Vertical scrollbar
        height: "6px", // Horizontal scrollbar
    },

    "&::-webkit-scrollbar-track": {
        background: "transparent",
    },

    "&::-webkit-scrollbar-thumb": {
        background: "#A0A0A0",
        borderRadius: "10px",
    },

    "&::-webkit-scrollbar-thumb:hover": {
        background: "#777777",
    },
};

const formatDateOnly = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);

    return `${day}/${month}/${year}`;
};

const formatLastActive = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) return "N/A";

    const datePart = formatDateOnly(dateString);

    const timePart = date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    return `${datePart} - ${timePart}`;
};

const RetailerList = () => {
    // Single set of pagination state variables
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    // Filter state variables
    const [status, setStatus] = useState("");
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isFilterActive, setIsFilterActive] = useState(false);
    const [tempStartDate, setTempStartDate] = useState("");
    const [tempEndDate, setTempEndDate] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(true);

    const handleSwitch = () => {
     let a= isLoggedIn?false:true;
     setIsLoggedIn(a);
    };

    // Data and UI state
    const [menu, setMenu] = useState([]);
    const [selectedManufacturer, setSelectedManufacturer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const containerRef = useRef(null);
    const currentPageRef = useRef(0);
    const isFetchingRef = useRef(false);
    const requestIdRef = useRef(0);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        isOpen: isDetailsOpen,
        onOpen: onDetailsOpen,
        onClose: onDetailsClose
    } = useDisclosure();

    const axiosInstance = useAxios();
    const { authToken } = useAuth();

    // Search Handler
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    }

    // Status filter handler
    const statusHandler = (newStatus) => {
        // Status
        if (status === newStatus) {
            setStatus("");
        } else {
            setStatus(newStatus);
        }
        // Current page
        setCurrentPage(1);
    };

    // Handle pagination
    // const handlePageChange = (newPage) => {
    //     setCurrentPage(newPage);
    // };

    // // Handle items per page change
    // const handleItemsPerPageChange = (e) => {
    //     setItemsPerPage(Number(e.target.value));
    //     setCurrentPage(1); // Reset to first page when changing items per page
    // };

    // Date filter product
    const applyDateFilter = () => {
  setStartDate(tempStartDate);
  setEndDate(tempEndDate);
  setIsFilterActive(!!tempStartDate && !!tempEndDate);
  setCurrentPage(1);
  onClose();
};


    const resetDateFilter = () => {
  setTempStartDate("");
  setTempEndDate("");
  setStartDate("");
  setEndDate("");
  setIsFilterActive(false);
  setCurrentPage(1);
  onClose();
};


    // View manufacturer details
    const retailerDetails = (id) => {
        const retailer = menu.find(item => item.id === id);
        if (retailer) {
            // Convert to the format expected by the modal
            const formattedRetailer = {
                RetailerID: retailer.id,
                CompanyName: retailer.firmName,
                Email: retailer.Email,
                Phone: retailer.Phone,
                PartyCode: retailer.retailerID,
                Location: retailer.Address,
                UpdatedAt: retailer.UpdatedAt,
                CreatedAt: retailer.CreatedAt,
                Status: retailer.Status ? "Active" : "Inactive",
                // Add any additional fields needed
                ContactPerson: "Contact Person",
                ContactPhone: "+1234567890",
                Address: retailer.Address || "123 Main Street, City, Country",
                Description: "Brief description about the manufacturer."
            };

            setSelectedManufacturer(formattedRetailer);
            onDetailsOpen();
        }
    };

    const [totalRespItems,setTotalRespItems]=useState(25);

    const fetchRetailer = async (pageNumber = 1, resetList = false) => {
        // Prevent duplicate requests while loading the next page.
        if (!resetList && isFetchingRef.current) return;
    
        isFetchingRef.current = true;
    
        if (!resetList) {
            isFetchingRef.current = true;
            setIsLoadingMore(true);
        } else {
            setLoading(true);
        }
    
        const requestId = resetList
            ? ++requestIdRef.current
            : requestIdRef.current;
    
        try {
            const response = await axios.get(
                `${Config.Retailerlist_url}?page=${pageNumber}&limit=${itemsPerPage}&status=${status}&companyName=${encodeURIComponent(searchTerm)}&startDate=${startDate}&endDate=${endDate}&isloggedIn=${isLoggedIn}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                }
            );
    
            // Ignore responses belonging to older filters/searches.
            if (requestId !== requestIdRef.current) return;
    
            if (response.status === 200) {
                const data = response?.data?.data;
                const newData = data?.retailers || [];
    
                // Append the next page; replace the list on page 1.
                setMenu((prev) =>
                    resetList ? newData : [...prev, ...newData]
                );
    
                setTotalItems(data?.totalRetailers ?? 0);
                setTotalRespItems(data?.totalRetailers ?? 0);
                setTotalPages(data?.totalPages ?? 1);
    
                setCurrentPage(pageNumber);
                currentPageRef.current = pageNumber;
    
                // Stop when the last page has been reached.
                setHasMore(
                    data?.totalPages != null
                        ? pageNumber < data.totalPages
                        : newData.length === itemsPerPage
                );
            }
        } catch (err) {
            console.log(err, "error fetching distributors");
        } finally {
            if (requestId === requestIdRef.current) {
                setLoading(false);
                setIsLoadingMore(false);
                isFetchingRef.current = false;
            }
        }
    };

    // useEffect(() => {
    //     const fetchData = async () => {
    //         setLoading(true);
    //         try {

    //             const response = await axios.get(`${Config.Retailerlist_url}?page=${currentPage}&limit=${itemsPerPage}&status=${status}&firmName=${searchTerm}&startDate=${startDate}&endDate=${endDate}&isloggedIn=${isLoggedIn}`, {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem('authToken')}`
    //                 }
    //             });

    //             if (response.status === 200) {
    //                 setMenu(response?.data?.data?.retailers || []);
    //                setTotalRespItems(response?.data?.data?.totalRetailers)
    //                 setTotalItems(response?.data?.data?.totalItems || response?.data?.retailers?.length || 0);
    //                 setTotalPages(response?.data?.data?.totalPages || Math.ceil((response?.data?.retailers?.length || 0) / itemsPerPage));
    //                 console.log(response?.data?.retailers, 'retailersData');
    //             }
    //         } catch (err) {
    //             console.log(err, 'error here');
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchData();
        
    // }, [currentPage, itemsPerPage, status, searchTerm, isFilterActive, startDate, endDate, isLoggedIn]);

    // Format date for display
    
    // Fetch page 1 whenever search or filters change.
useEffect(() => {
    setMenu([]);
    setCurrentPage(1);
    currentPageRef.current = 0;
    setHasMore(true);
    setIsLoadingMore(false);
    isFetchingRef.current = false;

    if (containerRef.current) {
        containerRef.current.scrollTop = 0;
    }

    fetchRetailer(1, true);
}, [
    itemsPerPage,
    status,
    searchTerm,
    isFilterActive,
    startDate,
    endDate,
    isLoggedIn,
]);

// Handle infinite scroll
const handleScroll = () => {
    const scrollArea = containerRef.current;

    if (!scrollArea || isFetchingRef.current || !hasMore) return;

    const { scrollTop, clientHeight, scrollHeight } = scrollArea;

    if (scrollTop + clientHeight >= scrollHeight - 20) {
        const nextPage = currentPageRef.current + 1;

        if (nextPage <= totalPages) {
            fetchRetailer(nextPage);
        }
    }
};

// Debounce scroll events
const debounce = (fn, delay) => {
    let timer;

    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
};
    
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return dateString; // Already in readable format
    };

    const nav = useNavigate();

    function handleNav(item) {
        console.log(item)
        nav(`/retailers/RetailerProfile/${item?.retailerID}`);
    }
//  Checkbox state
const [selectedRows, setSelectedRows] = useState([]);

// //  Row select
const handleCheckboxChange = (id) => {
  setSelectedRows((prev) =>
    prev.includes(id)
      ? prev.filter((rowId) => rowId !== id)
      : [...prev, id]
  );
};

//  Select All
const handleSelectAll = (checked) => {
  if (checked) {
    setSelectedRows(menu.map((item) => item.retailerID));
  } else {
    setSelectedRows([]);
  }
};

  const handleDownload = async () => {
    try {
      const response = await fetch(`${Config.Retailerlist_url}/download`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      // Response ko Blob (binary data) me convert karna
      const blob = await response.blob();

      // File URL banana
      const url = window.URL.createObjectURL(blob);

      // Anchor tag bana ke programmatically click karna
      const link = document.createElement("a");
      link.href = url;
      link.download = "retailer.csv"; 
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const navBusinessDetails = (item) => {
    if (!item?.retailerID) return;

    nav(`/retailers/business-details/${item.retailerID}`, {
        state: {
            disName: item?.firmName,
        },
    });
  };

    return (
        <Box p={4} px={1} pt={1.5} bg="white" borderRadius="15px" boxShadow="sm" overflow={"hidden"}>
            <HStack justify="space-between" alignItems="center" mb="5px">
                <Text fontSize="14px">Retailers</Text>
                <HStack alignSelf={"end"}>
                    <Flex gap="10px" alignItems="center">

                    <Flex align="center" border="1px solid #ccc" borderRadius="10px" p="5px" height="32px">
                            <Image src={searchIcon} alt="search" width="16px" />
                            <Input
                                
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder="Search"
                                border="none"
                                ml="5px"
                                fontSize="14px"
                                height="22px"
                            />
                        </Flex>
                    

                        <Button
                            onClick={() => statusHandler("Active")}
                            size="sm"
                            color="white"
                            bg={status === "Active" ? "#1D9C2A" : "#2EB33B"}
                            borderRadius="15px"
                            h={"30px"}
                            boxShadow={status === "Active" ? "0 0 0 2px #1D9C2A inset" : "none"}
                        >
                            Active
                        </Button>
                        
                        

                            
                        

                        <Button
                            onClick={() => statusHandler("Inactive")}
                            size="sm"
                            color="white"
                            h={"30px"}
                            bg={status === "Inactive" ? "#B84F4F" : "#CC5F5F"}
                            borderRadius="15px"
                            boxShadow={status === "Inactive" ? "0 0 0 2px #B84F4F inset" : "none"}
                        >
                            Blocked
                        </Button>
                        <Flex align={"center"}>
                            <Text
                                fontSize={"14px"}
                                // color={"white"} 
                                // bg={"gray.600"} 
                                borderRadius={"10px"}
                                padding={"5px"}
                                fontWeight={"bold"}
                            >
                                Logged in at least once
                            </Text>
                            <Switch
                                size={"md"}
                                marginRight={"15px"}
                                isChecked={isLoggedIn}
                                onChange={handleSwitch}
                            />
                        </Flex>
                    </Flex>

                    <Button
                        size="sm"
                        fontWeight={"400"}
                        border={"1px solid #53545C"}
                        fontSize={"11px"}
                        alignSelf={"end"}
                        onClick={onOpen}
                        height={"30px"}
                        bg={isFilterActive ? "#E9F2FF" : "white"}
                        color={isFilterActive ? "#3182CE" : "inherit"}
                        borderColor={isFilterActive ? "#3182CE" : "#53545C"}
                    >
                        <img src={filterIcon} alt="filter" style={{ marginRight: "5px" }} />
                        {isFilterActive ? "Filtered" : "Filter"}
                    </Button>

                     <Button
                        size="sm"
                        fontWeight="400"
                        border="1px solid #53545C"
                        fontSize="11px"
                        bg="white"
                        gap={'1'}
                        height={"30px"}
                        onClick={handleDownload}
                    ><TbDownload />
                        Download
                    </Button>
                </HStack>
            </HStack>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Date Filter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel>Start Date</FormLabel>
                           <Input
                             type="date"
                             value={tempStartDate}
                             onChange={(e) => setTempStartDate(e.target.value)}
                             max={tempEndDate || undefined}
                           />

                        </FormControl>

                        <FormControl mt={4}>
                            <FormLabel>End Date</FormLabel>
                            <Input
                             type="date"
                             value={tempEndDate}
                             onChange={(e) => setTempEndDate(e.target.value)}
                             min={tempStartDate || undefined}
                           />
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button onClick={applyDateFilter} mr={'10px'}variant={'outline'}>
                            Apply
                        </Button>
                        <Button onClick={resetDateFilter} variant="outline">Reset</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            
            {/* Manufacturer Details Modal */}
            <Modal isOpen={isDetailsOpen} onClose={onDetailsClose} size="lg">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Manufacturer Details</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        {loading ? (
                            <Text>Loading details...</Text>
                        ) : selectedManufacturer ? (
                            <Box>
                                <HStack justifyContent="space-between" mb={4}>
                                    <Text fontSize="xl" fontWeight="bold">{selectedManufacturer.CompanyName}</Text>
                                    <Badge
                                        px={3}
                                        py={1}
                                        borderRadius="8px"
                                        colorScheme={selectedManufacturer.Status === "Active" ? "green" : "red"}
                                    >
                                        {selectedManufacturer.Status}
                                    </Badge>
                                </HStack>

                                <Divider mb={4} />

                                <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Email</Text>
                                        <Text>{selectedManufacturer.Email}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Phone</Text>
                                        <Text>{selectedManufacturer.Phone}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Party Code</Text>
                                        <Text>{selectedManufacturer.PartyCode}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Location</Text>
                                        <Text>{selectedManufacturer.Location}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">User Since</Text>
                                        <Text>{formatDate(selectedManufacturer.CreatedAt)}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Last Active</Text>
                                        <Text>{formatDate(selectedManufacturer.UpdatedAt)}</Text>
                                    </GridItem>
                                </Grid>

                                {selectedManufacturer.Address && (
                                    <Box mt={4}>
                                        <Text fontSize="sm" color="gray.500">Address</Text>
                                        <Text>{selectedManufacturer.Address}</Text>
                                    </Box>
                                )}

                                {selectedManufacturer.Description && (
                                    <Box mt={4}>
                                        <Text fontSize="sm" color="gray.500">Description</Text>
                                        <Text>{selectedManufacturer.Description}</Text>
                                    </Box>
                                )}

                                <Divider my={4} />

                                <Box>
                                    <Text fontSize="sm" mb={2}>Contact Person</Text>
                                    <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                                        <GridItem>
                                            <Text fontSize="sm" color="gray.500">Name</Text>
                                            <Text>{selectedManufacturer.ContactPerson || "N/A"}</Text>
                                        </GridItem>
                                        <GridItem>
                                            <Text fontSize="sm" color="gray.500">Phone</Text>
                                            <Text>{selectedManufacturer.ContactPhone || "N/A"}</Text>
                                        </GridItem>
                                    </Grid>
                                </Box>
                            </Box>
                        ) : (
                            <Text>No details available</Text>
                        )}
                    </ModalBody>

                    <ModalFooter>
                        <Button onClick={onDetailsClose}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Box 
                overflowX="auto"
                ref={containerRef}
                sx={thinScrollbarStyles}
                onScroll={debounce(handleScroll, 100)}
                h="calc(100vh - 300px)"
                w={"100%"}
                minH="250px"
                maxH="calc(100vh - 220px)"
                borderTop={"1px solid #ecececff"}
                borderX={"1px solid #ecececff"} 
                borderBottom={"1px solid #ecececff"} 
                overflowY={'auto'}
            >
                <Table 
                    variant="simple" 
                    w={"full"} 
                    sx={{
                        borderCollapse: "seperate", 
                        borderSpacing: 0, 
                        tableLayout: "fixed"
                    }} 
                    size={"sm"}
                    borderX={"1px solid #ecececff"} 
                    borderBottom={"1px solid #ecececff"} 
                    h={"auto"}
                    overflowY={'auto'} 
                    overflowX={'auto'}
                >
                    <colgroup>
                        <col style={{ width: "32px" }} />   {/* Checkbox */}
                        <col style={{ width: "185px" }} />  {/* Retailer */}
                        <col style={{ width: "115px" }} />  {/* User Since */}
                        <col style={{ width: "135px" }} />  {/* Valid Until */}
                        <col style={{ width: "155px" }} />  {/* Last Active */}
                        <col style={{ width: "110px" }} />  {/* Phone */}
                        <col style={{ width: "245px" }} />  {/* Email */}
                        <col style={{ width: "105px" }} />  {/* Party Code */}
                        {/* <col style={{ width: "145px" }} />  Action */}
                        <col style={{ width: "280px" }} />  {/* Location */}
                        <col style={{ width: "105px" }} />  {/* Status */}
                        {/* <col style={{ width: "145px" }} />  Role Details */}
                        <col style={{ width: "140px" }} />  {/* Profile */}
                    </colgroup>
                    <Thead position={"sticky"} top={0} zIndex={2} bg={"rgb(250, 250, 250)"}>
                        <Tr bg={"rgb(250, 250, 250)"} height={"36px"}>
                            <Th minW={"32px"} maxW={"32px"}>
                                <Checkbox
                                    isChecked={selectedRows.length === menu.length && menu.length > 0}
                                    isIndeterminate={
                                        selectedRows.length > 0 && selectedRows.length < menu.length
                                    }
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                /></Th>
                            {tableHeadings.map((item, index) => (
                                <Th 
                                    key={index}
                                    textTransform="none" 
                                    fontWeight="500" 
                                    color="black" 
                                    py={"8px"} 
                                    fontSize="13px" 
                                    whiteSpace={"nowrap"}
                                    overflow={"hidden"} 
                                >
                                    <Flex justify={"space-between"} gap={"4px"} w={"100%"} align="center" minW={0}>
                                        <Text
                                            fontSize="13px"
                                            fontWeight="500"
                                            whiteSpace="nowrap"
                                            flexShrink={0}
                                        >
                                            {item}
                                        </Text>
                                        <Image src={sortIcon} alt="sort" width="14px" height={"14px"} minW={"14px"} flexShrink={0} ml="2" />
                                    </Flex>
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                    <Tbody overflowY={"auto"}>
                        {loading ? (
                            <Tr>
                                <Td colSpan={tableHeadings.length + 1} textAlign="center" py={4}>
                                    Loading...
                                </Td>
                            </Tr>
                        ) : menu?.length > 0 ? (
                            menu.map((item) => (
                                <Tr 
                                    minH={'36px !important'}
                                    maxH={'36px !important'} 
                                    key={item.id}
                                    fontSize={"12px"}  
                                    sx={{
                                        "& td": {
                                            borderBottom: "1px solid #edf0f5",
                                            py: "4px",
                                            fontWeight: "400"
                                        },
                                    }}
                                >
                                    <Td>
                                        <Checkbox
                                            isChecked={selectedRows.includes(item.retailerID)}  
                                            onChange={() => handleCheckboxChange(item.retailerID)}
                                        />
                                    </Td>
                                    <Td px="12px" overflow="hidden" minW={0}>
                                            <Tooltip label={item.firmName || "-"} placement="top" hasArrow>
                                                <Text
                                                    fontSize="12px"
                                                    color="#6E7079"
                                                    whiteSpace="nowrap"
                                                    overflow="hidden"
                                                    textOverflow="ellipsis"
                                                    cursor="pointer"
                                                    onClick={() =>
                                                        handleNav(item)
                                                    }
                                                >
                                                    {item.firmName || "-"}
                                                </Text>
                                            </Tooltip>
                                            {/* {item["firmName"]}  */}
                                    </Td>
                                    <Td cfontSize="12px" color="#6E7079" whiteSpace="nowrap" overflow="hidden">
                                        <Text whiteSpace="nowrap">
                                            {formatDateOnly(item.CreatedAt)}
                                        </Text>
                                        {/* {item["CreatedAt"] ? new Date(item["CreatedAt"]).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : "N/A"} */}
                                    </Td>
                                    <Td fontSize="12px" color="#6E7079" whiteSpace="nowrap" overflow="hidden">
                                        <Text whiteSpace="nowrap">
                                            {formatDateOnly(item.expiryDate)}
                                        </Text>
                                    </Td>
                                    <Td fontSize="12px" color="#6E7079" whiteSpace="nowrap" overflow="hidden">
                                        {/* {item["UpdatedAt"] ? `${new Date(item["UpdatedAt"]).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })} -  ${new Date(item["UpdatedAt"]).toLocaleTimeString('en-IN')}` : "N/A"} */}
                                        <Text whiteSpace={"nowrap"}>
                                            {formatLastActive(item.UpdatedAt)}
                                        </Text>
                                    </Td>
                                    <Td fontSize={"12px"} color="#6E7079" overflow={"hidden"}>
                                        <Text whiteSpace="nowrap">{item["Phone"]}</Text>
                                    </Td>
                                    <Td
                                        fontSize="12px"
                                        overflow="hidden"
                                        minW={0}
                                        maxW="285px"
                                    >
                                        <Flex 
                                            align="center"
                                            gap={2}
                                            minW={0}
                                            width="100%"
                                            overflow="hidden"
                                        >
                                            <Tooltip
                                                label={item.Email || "-"}
                                                placement="top"
                                                hasArrow
                                            >
                                                <Text
                                                    color="#6E7079"
                                                    flex="1"
                                                    minW={0}
                                                    whiteSpace="nowrap"
                                                    overflow="hidden"
                                                    textOverflow="ellipsis"
                                                >
                                                    {item.Email || "-"}
                                                </Text>
                                            </Tooltip>
                                            <IconButton
                                                icon={<Image src={copyIcon} width="12px" />}
                                                size="xs"
                                                flexShrink={0}
                                                ml={0}
                                                variant="ghost"
                                                onClick={() => navigator.clipboard.writeText(item.Email || "")}
                                                aria-label="Copy email"
                                            />
                                        </Flex>
                                    </Td>
                                    <Td fontSize={"12px"} paddingLeft={"1rem"} paddingRight={"1rem"} color="#6E7079">
                                        {item["retailerCode"]}
                                    </Td>
                                    <Td
                                        fontSize="12px"
                                        color="#6E7079"
                                        overflow="hidden"
                                        minW={0}
                                    >
                                        <Tooltip
                                            label={item.Address || "-"}
                                            placement="top"
                                            hasArrow
                                        >
                                            <Text
                                                noOfLines={2}
                                                lineHeight="18px"
                                                maxH="36px"
                                                overflow="hidden"
                                                wordBreak="break-word"
                                            >
                                                {item.Address || "-"}
                                            </Text>
                                        </Tooltip>
                                    </Td>
                                    {/* <Td color="#6E7079">
                                        {item["UpdatedAt"] ? `${new Date(item["UpdatedAt"]).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })} -  ${new Date(item["UpdatedAt"]).toLocaleTimeString('en-IN')}` : "N/A"}
                                    </Td> */}
                                    {/* <Td color="#6E7079">
                                        {item["CreatedAt"] ? new Date(item["CreatedAt"]).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : "N/A"}
                                    </Td> */}
                                    <Td fontSize={"12px"}>
                                        <Button
                                           size="xs"
                                           backgroundColor={
                                             item.Status === 'Active'
                                               ? '#32936f2b' 
                                               : item.Status === 'Inactive'
                                               ? '#cc5f5f4f' 
                                               : ''  
                                           }
                                           color={
                                             item.Status === 'Active'
                                               ? '#519C66' 
                                               : item.Status === 'Inactive'
                                               ? '#cc5f5f' 
                                               : '' 
                                           }
                                           borderRadius="8px"
                                         >
                                           {item.Status === 'Active'
                                             ? 'Active'
                                             : item.Status === 'Inactive'
                                             ? 'Blocked'
                                             : ''}
                                         </Button>
                                    </Td>
                                    <Td fontSize={"12px"}>
                                        {/* <IconButton
                                            onClick={() => handleNav(item)}
                                            icon={<Image src={eyeIcon} width="18px" />}
                                            variant="ghost"
                                            size="sm"
                                        /> */}
                                        <Button fontSize={"12px"} h={"30px"} onClick={() => handleNav(item)}>
                                            View Profile
                                        </Button>
                                    </Td>
                                </Tr>
                            ))
                        ) : (
                            <Tr>
                                <Td colSpan={tableHeadings.length + 1} textAlign="center" py={4}>
                                    {loading ? "Loading..." : "No items found"}
                                </Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>

               
            </Box>
             {/* Pagination UI */}
             {/* <Box>
                {!loading && menu && menu.length > 0 && (
                    <Flex justify="space-between" align="center" mt={4}>
                        <Flex align="center">
                            <Select
                                size="sm"
                                w="70px"
                                height="23px"
                                borderRadius="8px"
                                backgroundColor="#f0f4f9"
                                mr={2}
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>

                            </Select>
                            <Text fontSize="sm" color="#666666">Items per page</Text>
                            <Text fontSize="14px" color="#666666" marginLeft="12px">
                                {Math.min(1 + (currentPage - 1) * itemsPerPage, totalRespItems)}-
                                {Math.min(currentPage * itemsPerPage, totalRespItems)} of {totalRespItems} items
                            </Text>
                        </Flex>

                        <Flex align="center">
                            <Select
                                size="sm"
                                w="60px"
                                height="23px"
                                borderRadius="8px"
                                backgroundColor="#f0f4f9"
                                mr={1}
                                value={currentPage}
                                onChange={(e) => handlePageChange(Number(e.target.value))}
                            >
                                {[...Array(totalPages).keys()].map(page => (
                                    <option key={page + 1} value={page + 1}>{page + 1}</option>
                                ))}
                            </Select>
                            <Text fontSize="14px" color="#666666" marginLeft="8px">of {totalPages} pages</Text>
                            <IconButton
                                icon={<FiChevronLeft />}
                                variant="ghost"
                                size="sm"
                                aria-label="Previous page"
                                mr={1}
                                onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                                isDisabled={currentPage === 1}
                            />

                            <IconButton
                                icon={<FiChevronRight />}
                                variant="ghost"
                                size="sm"
                                aria-label="Next page"
                                onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                                isDisabled={currentPage === totalPages}
                            />
                        </Flex>
                    </Flex>
                )}
            </Box> */}
        </Box>
    );
};

export default RetailerList;